
// NOTE - Instances codes
export const LATAM_INSTANCES = ["mx", "la"];
export const INSTANCES_TO_SKIP_AND_NOT_SHOW = ["sm", "rc", "mx"];